import React, { Component } from "react";
import "./style.scss";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import Heading from "../../elements/heading";

export default class TextContent extends Component {
  textContent(fields, className) {
    const { paddingAboveTop, paddingAboveBottom, gridType, backgroundColor, alignment, overline, headingBody, headingType, body, otherClass } = fields;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "default",
      grid = gridType ? gridType.fields.phrase.value : "normal",
      gridClass = grid === "story" ? "grid-story" : grid === "normal" ? "grid" : grid === "full-width" ? "full-width" : "grid";
    const textContentClasses = classNames("text-content", className, "padding-top-" + top, "padding-bottom-" + bottom, gridClass);

    let backgroundStyle = {};
    backgroundStyle = {
      background: backgroundColor ? backgroundColor.fields.phrase.value : ""
    };
    const contentClasses = classNames("content", alignment ? alignment.fields.phrase.value : "", otherClass ? otherClass.value : '');
    return (
      <div className={textContentClasses} style={backgroundStyle} datasourceid={this.props?.rendering?.dataSource}>
        <div className={contentClasses}>
          {overline && <p className="overline">{overline.value}</p>}
          {headingBody && (
            <Heading
              {...{
                html: headingBody,
                type: headingType
              }}
              className={"title"}
            />
          )}
          {body && <RichText tag="div" className={"body-text"} field={body} />}
        </div>
      </div>
    );
  }

  documentChange(fields) {
    let { headingBody, body } = fields;
    if (headingBody) {
      let node = document.createElement("div");
      node.innerHTML = headingBody.value;

      if (node.firstChild && node.firstChild.className === "") {
        node.firstChild.className = "type-h1";
        headingBody.value = node.innerHTML;
      }
    }

    // set default heading style if non is set from the RTF in sitecore
    if (body) {
      let node2 = document.createElement("div");
      node2.innerHTML = body.value;

      let resultNode = document.createElement("div");

      let array = Array.from(node2.children);
      array.forEach(element => {
        if (element && element.firstChild) {
          if (element.nodeName === "H1" && element.firstChild.className === "") {
            element.firstChild.className = "type-h1";
          } else if (element.nodeName === "H2" && element.firstChild.className === "") {
            element.firstChild.className = "type-h2";
          } else if (element.nodeName === "H3" && element.firstChild.className === "") {
            element.firstChild.className = "type-h3";
          } else if (element.nodeName === "H4" && element.firstChild.className === "") {
            element.firstChild.className = "type-h4";
          }
        }
        resultNode.appendChild(element);
      });

      body.value = resultNode.innerHTML;
    }
  }
  componentDidMount(props) {
    const { fields } = this.props;
    this.documentChange(fields);
  }

  render() {
    if (!this.props.fields) return null;
    const { fields, className } = this.props;
    const { gridType } = fields;
    if ((gridType && gridType.fields.phrase.value) === "story") {
      return <div className={"grid"}>{this.textContent(fields, className)}</div>;
    } else {
      return this.textContent(fields, className);
    }
  }
}
